{
  "markread": "Marca com llegit",
  "filter": "Filtre",
  "newest": "Nous",
  "unread": "Per llegir",
  "starred": "Preferits",
  "online_count": "Elements disponibles al servidor",
  "offline_count": "Elements disponibles localment",
  "tags": "Etiquetes",
  "alltags": "Totes les etiquetes",
  "timestamp": "{0,date} {0,time}",
  "hours": "fa {0,plural,one {1 hora},other {# hores}}",
  "minutes": "fa {0,plural,one {1 minut},other {# minuts}}",
  "seconds": "fa {0,plural,one {1 segon},other {# segons}}",
  "days": "{0,plural,zero {avui},one {ahir},other {fa # dies}}",
  "star": "Preferit",
  "unstar": "Ja no ho prefereixo",
  "mark": "Marca com llegit",
  "unmark": "Marca com no llegit",
  "load_img": "Mostra les imatges",
  "open_window": "Obre",
  "next": "Següent",
  "searchbutton": "Cerca",
  "searchremove": "Amaga la cerca",
  "refreshbutton": "Actualitza les fonts",
  "settingsbutton": "Configuració",
  "logoutbutton": "Finalitza la sessió",
  "loginbutton": "Inicia una sessió",
  "sources": "Fonts",
  "source_add": "Afegeix una font",
  "source_opml": "o importa des d'un fitxer opml o des del Google Reader (fins al 15 de juliol de 2013)",
  "source_export": "Exporta les fonts",
  "source_edit": "Edita",
  "source_filter": "Filtra",
  "source_delete": "Esborra",
  "source_warn": "Segur que voleu esborrar la font?",
  "source_new": "Nova font per desar",
  "source_title": "Títol",
  "source_autotitle_hint": "Deixa en blanc per a obtindre el títol",
  "source_tags": "Etiquetes",
  "source_pwd_placeholder": "No ha canviat",
  "source_comma": "Separat per comes",
  "source_select": "Seleccioneu una font",
  "source_type": "Tipus",
  "source_save": "Desa",
  "source_cancel": "Cancel·la",
  "source_saved": "Desat",
  "source_last_post": "Última entrada vista",
  "source_refresh": "Actualitza aquesta font",
  "no_entries": "No es van trobar entrades",
  "more": "Més",
  "login": "Inicia una sessió",
  "login_username": "Nom d'usuari",
  "login_password": "Contrasenya",
  "login_invalid_credentials": "Nom d'usuari o contrasenya incorrectes",
  "login_offline": "Emmagatzematge fora de línia",
  "no_title": "Sense títol",
  "error": "S'ha produït un error",
  "streamerror": "No hi ha cap element carregat. Es recarrega?",
  "reload_list": "Recarrega la llista",
  "sources_refreshed": "S'han actualitzat les fonts",
  "app_update": "selfoss s'ha actualitzat, torneu a carregar",
  "app_reload": "Recarrega",
  "error_session_expired": "La sessió ha expirat",
  "error_add_source": "No s'ha pogut afegir la font:",
  "error_delete_source": "No s'ha pogut esborrar la font:",
  "error_load_tags": "No s'han pogut carregar les etiquetes:",
  "error_unknown_tag": "Etiqueta desconeguda:",
  "error_unknown_source": "Id de font desconeguda:",
  "error_mark_items": "No s'han pogut marcar tots els elements visibles:",
  "error_mark_item": "No s'ha pogut marcar/desmarcar element:",
  "error_star_item": "No s'ha pogut preferir/despreferir l'element:",
  "error_logout": "No s'ha pogut finalitzar la sessió:",
  "error_loading": "Error de càrrega:",
  "error_loading_stats": "No s'han pogut carregar les estadístiques de navegació:",
  "error_saving_color": "No s'ha pogut desar el nou color:",
  "error_refreshing_source": "No s'han pogut refrescar fonts:",
  "error_sync": "No s'han pogut sincronitzar els últims canvis del servidor:",
  "error_offline_storage": "Error d'emmagatzematge fora de línia: {0}. Recarregar pot ajudar. Es desactiva l'ús fora de línia per ara.",
  "error_invalid_subsection": "Subsecció invàlida:",
  "search_label": "Terme de cerca",
  "article_actions": "Accions",
  "error_configuration": "No es pot carregar la configuració.",
  "info_url_copied": "S'ha copiat l'URL al portaretalls.",
  "share_native_label": "Comparteix",
  "share_diaspora_label": "Comparteix a Diaspora",
  "share_twitter_label": "Comparteix al Twitter",
  "share_facebook_label": "Comparteix al Facebook",
  "share_pocket_label": "Desa a Pocket",
  "share_wallabag_label": "Desa a Wallabag",
  "share_wordpress_label": "Comparteix a WordPress",
  "share_mail_label": "Comparteix per correu electrònic",
  "share_copy_label": "Copia l'enllaç al portaretalls",
  "error_share_native_abort": "No es pot compartir l'element—o no hi ha destinacions de compartició, o ho heu cancel·lat.",
  "error_share_native": "No es pot compartir l'element.",
  "close_entry": "Tanca",
  "error_unwritable_logs": "No es poden escriure els registres.",
  "error_check_system_logs": "S'ha produït un error. Comproveu els registres del sistema.",
  "error_check_log_file": "S'ha produït un error. Comprova el fitxer de registre “{0}”.",
  "offline_navigation_unavailable": "Canviar etiquetes i fonts no és disponible en el mode fora de línia.",
  "error_offline_storage_not_available": "Emmagatzematge fora de línia no disponible. Assegureu-vos que el navegador {0}suporta IndexedDB API{1}. Si utilitzeu un navegador basat en Google Chrome, que no estigueu utilitzant selfoss en mode incògnit.",
  "error_edit_source": "No es pot desar els canvis a les fonts:",
  "article_reading_time": "{0} min lectura",
  "experimental": "Experimental",
  "source_menu": "Més accions",
  "source_browse": "Navega",
  "sources_leaving_unsaved_prompt": "Voleu deixar la configuració amb els canvis de font no desats?",
  "source_warn_cancel_dirty": "Vols descartar els canvis no desats?",
  "tag_change_color_button_title": "Canvia el color",
  "sources_loading": "S'estan carregant les fonts…",
  "source_deleting": "S'està suprimint la font…",
  "source_params_loading": "S'estan carregant els paràmetres…",
  "no_sources": "No hi ha fonts configurades.",
  "source_saving": "S'estan desant els canvis a la font…",
  "source_go_to_settings": "Obre a la configuració",
  "entries_loading": "S'estan carregant les entrades…",
  "login_in_progress": "S'està intentant iniciar sessió…",
  "login_error_generic": "No s'ha pogut iniciar sessió: {errorMessage}",
  "error_unauthorized": "Si us plau, {link_begin}inicieu sessió{link_end} per a continuar.",
  "share_mastodon_label": "Comparteix a Mastodon"
}
